import { useQuery } from '@apollo/client';
import * as React from 'react';
import Confetti from 'react-dom-confetti';
import {
  GetBeeStatistics,
  GetBeeStatisticsQuery,
  GetBeeStatisticsQueryVariables,
} from '../../../../shared/api-clients/gql';
import { SummaryCard } from '../../components/summaryCard';
import { ListBeesProvider } from '../../contexts/listBees';
import { useListFilter } from '../../contexts/listFilter';
import { ListBeesTable } from '../../tables/listbees';

export const HomeView: React.FunctionComponent = () => {
  const { queryOptions } = useListFilter();

  const { data, loading } = useQuery<GetBeeStatisticsQuery, GetBeeStatisticsQueryVariables>(GetBeeStatistics, {
    fetchPolicy: 'network-only',
    pollInterval: 10000,
    variables: { query: queryOptions },
  });

  const isLoading = loading;
  const [isConfettiActive, setConfettiActive] = React.useState(false);

  React.useEffect(() => {
    setInterval(() => {
      setConfettiActive(true);
    }, 1000);
  }, []);
  return (
    <>
      <Confetti
        active={isConfettiActive && data?.getBeeStatistics?.totalBees === 1000}
        config={{
          angle: 90,
          spread: 360,
          startVelocity: 40,
          elementCount: 100,
          dragFriction: 0.12,
          duration: 3000,
          stagger: 3,
        }}
      />
      <div className="flex flex-row flex-wrap sero-bg-grey-background-1 sm:px-72 py-24" data-qa="home-summary">
        <SummaryCard icon="total" title="Total BEEs" value={data?.getBeeStatistics?.totalBees} />
        <SummaryCard icon="online" title="Online BEEs" value={data?.getBeeStatistics?.numberOfDevicesOnline} />
        <SummaryCard icon="offline" title="Offline BEEs" value={data?.getBeeStatistics?.numberOfDevicesOffline} />
        <SummaryCard
          icon="unhealthy"
          title="Healthcheck errors"
          value={data?.getBeeStatistics?.totalHealthcheckErrors}
        />
      </div>
      <div className="flex flex-auto min-h-screen" data-qa="home">
        <ListBeesProvider>
          <ListBeesTable />
        </ListBeesProvider>
      </div>
    </>
  );
};
